import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as IBAN from 'iban';

export class IBANService {
  static validateIban(c: AbstractControl): ValidationErrors {
    if (c.value && !IBAN.isValid(c.value)) {
      return { iban: { value: c.value } };
    }

    return null as any;
  }

  static validateBic(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null; // Allow empty values

    const bicValue = control.value.toString().toUpperCase().trim();

    // BIC format: 4 letters (bank code) + 2 letters (country code) + 2 alphanumeric (location) + optional 3 alphanumeric (branch)
    // Total length: 8 or 11 characters
    const bicRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

    if (!bicRegex.test(bicValue)) {
      return { bic: { value: control.value } };
    }

    return null;
  }
}
